import React, { useState } from "react";

export default function PrimaryButton({
  label,
  icon = null,
  onClick,
  ...props
}) {
  const [isClicked, setIsClicked] = useState(false);

  return (
    <button
      className={`primarybtn_button ${isClicked ? "primarybtn_clicked" : ""}`}
      onClick={onClick}
      onMouseDown={() => setIsClicked(true)}
      onMouseUp={() => setIsClicked(false)}
      onMouseLeave={() => setIsClicked(false)}
      {...props}
    >
      {label}
      {icon && <span className="primarybtn_icon">{icon}</span>}
    </button>
  );
}
